import React from 'react';
import {
  AlertDialog,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  Button,
  AlertDialogBody,
} from '@chakra-ui/react';

export default function CautionAlertDialog({
  onContinue,
  loading,
  button,
  cautionTitle,
  agree,
  disagree,
  buttonProps,
  children,
  size,
  yesLoading,
}) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();

  const BTN = {
    _focus: { boxShadow: 'none' },
    color: 'white',
    isLoading: yesLoading,
  };

  const handleClick = () => {
    onClose();
    onContinue(true);
  };

  return (
    <>
      <Button
        _focus={{ boxShadow: 'none', bg: 'none', border: 'none' }}
        _hover={{ opacity: '0.8' }}
        onClick={onOpen}
        isLoading={loading && loading}
        color='#fff'
        {...buttonProps}
      >
        {button}
      </Button>

      <AlertDialog
        motionPreset='slideInBottom'
        onClose={onClose}
        isOpen={isOpen}
        isCentered
        size={size || 'sm'}
      >
        <AlertDialogOverlay />

        <AlertDialogContent>
          <AlertDialogHeader>{cautionTitle}</AlertDialogHeader>
          <AlertDialogBody>{children}</AlertDialogBody>

          <AlertDialogFooter pt='3rem' gap='1rem'>
            <Button
              colorScheme='red'
              ref={cancelRef}
              onClick={onClose}
              _focus={{ boxShadow: 'none' }}
              w='70px'
            >
              {disagree || 'No'}
            </Button>
            <Button
              w='70px'
              {...BTN}
              onClick={handleClick}
              bg='primaryDark'
              ml={3}
            >
              {agree || 'Yes'}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
